







import { Component,  Vue } from 'vue-property-decorator';  
import {mapState} from 'vuex'
import { Action } from 'vuex-class'


@Component({ 
  computed: mapState([ 
    'carrinho','wineBox'
  ]),
})

export default class Header extends Vue {  
    @Action('TOGGLE_WINEBOX')
    TOGGLE_WINEBOX!: (TOGGLE_WINEBOX: void) => void 

    toggleWineBox(){ 
        this.TOGGLE_WINEBOX()
    }
}
